<script lang="ts">
	import Button from '../../Button.svelte';
	export let options = [];
	export let ageGroups = [];
	export let is_age_group_18_plus = false;
	export let is_age_group_18_minus = false;

	function onAgeClick(ageGrp: string, event: Event) {
		event.preventDefault();
		if (is_age_group_18_plus) {
			is_age_group_18_plus = false;
			ageGroups = [];
		}
		if (is_age_group_18_minus) {
			is_age_group_18_minus = false;
			ageGroups = [];
		}
		if (ageGroups.some((item) => item === ageGrp)) {
			ageGroups = ageGroups.filter((item) => item !== ageGrp);
		} else {
			const newAgeGroups = [...ageGroups, ageGrp];
			ageGroups = options.filter((item) => newAgeGroups.includes(item));
		}
	}

	function onAnyClick(event: Event) {
		event.preventDefault();
		if (is_age_group_18_plus) {
			is_age_group_18_plus = false;
			ageGroups = [];
		}
		if (is_age_group_18_minus) {
			is_age_group_18_minus = false;
			ageGroups = [];
		}

		ageGroups = options.length === ageGroups.length ? [] : options;
	}

	function on18PlusClick(event: Event) {
		event.preventDefault();
		is_age_group_18_plus = !is_age_group_18_plus;
		is_age_group_18_minus = false;
		is_age_group_18_plus
			? (ageGroups = ['25 - 34', '35 - 44', '45 - 54', '55+'])
			: (ageGroups = []);
	}

	function on18MinusClick(event: Event) {
		event.preventDefault();
		is_age_group_18_minus = !is_age_group_18_minus;
		is_age_group_18_plus = false;
		is_age_group_18_minus ? (ageGroups = ['0 - 14', '15 - 24']) : (ageGroups = []);
	}
</script>

<Button
	margin
	variant={(options.length === ageGroups.length || ageGroups.length === 0) &&
	is_age_group_18_plus === false
		? 'raised'
		: 'outlined'}
	on:click={onAnyClick}
>
	any
</Button>
{#each options as ageGrp}
	<Button
		margin
		variant={is_age_group_18_plus === false &&
		is_age_group_18_minus === false &&
		ageGroups.some((x) => x === ageGrp)
			? 'raised'
			: 'outlined'}
		on:click={(e) => onAgeClick(ageGrp, e)}
	>
		{ageGrp}
	</Button>
{/each}
<Button margin variant={is_age_group_18_plus ? 'raised' : 'outlined'} on:click={on18PlusClick}>
	18+
</Button>
<Button margin variant={is_age_group_18_minus ? 'raised' : 'outlined'} on:click={on18MinusClick}>
	18 -
</Button>
